import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import BeforeAfter from "@/components/BeforeAfter";
import Booking from "@/components/Booking";
import Testimonials from "@/components/Testimonials";
import ServiceArea from "@/components/ServiceArea";
import About from "@/components/About";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="font-body bg-white text-slate-900">
      <Header />
      <main>
        <Hero />
        <Services />
        <BeforeAfter />
        <Booking />
        <Testimonials />
        <ServiceArea />
        <About />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
